import { combineReducers } from '@reduxjs/toolkit';
import restaurantReducer from './restaurantSlice';
import siteContentReducer from './siteContentSlice';
import menuReducer from './menuSlice';
import cartReducer from './cartSlice';
import tpnConfigReducer from './tpnConfigSlice';
import comboReducer from './comboSlice';
import imageUploadReducer from './imageUploadSlice';
import orderReducer from './orderSlice';
import editModeReducer from './editModeSlice';
import editControlReducer from './editControlSlice';
import navEditModeReducer from './navEditModeSlice';
import footerEditModeReducer from './footerEditModeSlice';
import drawerReducer from './globalAIDrawerSlice';
import themeReducer from './themeSlice';
import tableAvailabilityReducer from './tableAvailabilitySlice';
import makeReservationReducer from './makeReservationSlice';

const rootReducer = combineReducers({
  restaurant: restaurantReducer,
  siteContent: siteContentReducer,
  menu: menuReducer,
  cart: cartReducer,
  tpnConfig: tpnConfigReducer,
  combo: comboReducer,
  imageUpload: imageUploadReducer,
  order: orderReducer,
  editMode: editModeReducer,
  editControl: editControlReducer,
  navEditMode: navEditModeReducer,
  footerEditMode: footerEditModeReducer,
  drawer: drawerReducer,
  theme: themeReducer,
  tableAvailability: tableAvailabilityReducer,
  makeReservation: makeReservationReducer,
});

export default rootReducer;
export type RootState = ReturnType<typeof rootReducer>;
